import { Table, TableContainer, TableBody, TableHead, TableRow } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/styles';
import { useSelector } from 'react-redux';
import Switch from '../../../common/switch';
import TooltipIcon from '../../../common/tooltip-icon';
import Loading from '../../../common/loading';
import l from '../../../../lang';
import { getCountryFlagUrl } from '../../../../utils';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info-unfilled.svg';
import { canToggleThreeDSecure } from '../../../../store/payment-methods/roles';
import { useThreeDSecureInfo } from '../../../../hooks/use-threed-secure-info';
import { Urls } from '../../../../config/urls';
import './styles.scss';

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#fafafa',
  },
  [`&.${tableCellClasses.head}:first-child `]: {
    borderTopLeftRadius: '8px',
  },
  [`&.${tableCellClasses.head}:last-child `]: {
    borderTopRightRadius: '8px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const formatCost = (cost: number) => `USD ${Number(cost).toFixed(2)}`;

function ThreeDSecure() {
  const { data, loading, error, toggleCountry } = useThreeDSecureInfo();
  const { auth } = useSelector((state: { auth?: { roles?: string[] } }) => state);
  const canToggle = canToggleThreeDSecure(auth?.roles);

  return (
    <div className="three-d-secure">
      <div className="payment-methods__subtitle">{l('paymentMethod.threedSecure.subtitle')}</div>
      <div className="payment-methods__desc">{l('paymentMethod.threedSecure.desc')}</div>
      {loading && (
        <div className="payment-methods__loading">
          <Loading />
        </div>
      )}
      {error && !loading && <div className="three-d-secure__error">{l('common.error')}</div>}
      {!loading && !error && (
        <>
          <TableContainer>
            <Table sx={{ minWidth: 700 }} aria-label="3DS table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>{l('paymentMethod.installments.header.country')}</StyledTableCell>
                  <StyledTableCell size="small">{l('paymentMethod.threedSecure.header.available')}</StyledTableCell>
                  <StyledTableCell>
                    <span className="three-d-secure__header-with-icon">
                      {l('paymentMethod.installments.header.cost')}
                      <TooltipIcon
                        placement="bottom"
                        text={l('paymentMethod.threedSecure.costTooltip')}
                        icon={<InfoIcon />}
                      />
                    </span>
                  </StyledTableCell>
                  <StyledTableCell size="small">{l('paymentMethod.threedSecure.header.enabled')}</StyledTableCell>
                  <StyledTableCell>{l('paymentMethod.threedSecure.header.coverage')}</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map(row => (
                  <TableRow key={row.country}>
                    <TableCell component="th" scope="row">
                      <div className="three-d-secure__country">
                        <img
                          alt={`img-country-${row.country}`}
                          className="three-d-secure__country-flag"
                          src={getCountryFlagUrl(row.country)}
                        />
                        <span>{l(`countryCode.${row.country}`)}</span>
                      </div>
                    </TableCell>
                    <TableCell>{row.available ? l('common.yes') : l('common.no')}</TableCell>
                    <TableCell>{formatCost(row.cost)}</TableCell>
                    <TableCell>
                      <div className="three-d-secure__toggle">
                        <Switch
                          checked={Boolean(row.available && row.enabled)}
                          onChange={() => toggleCountry(row.country, !row.enabled)}
                          disabled={!row.available || !canToggle}
                        />
                      </div>
                    </TableCell>
                    <TableCell>{l(`paymentMethod.threedSecure.coverage.${row.coverage}`)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <div className="three-d-secure__footer">
            <span>{l('paymentMethod.threedSecure.footer')}</span>{' '}
            <a
              className="three-d-secure__see-more"
              href={Urls.helpCenter}
              target="_blank"
              rel="noopener noreferrer"
            >
              {l('paymentMethod.threedSecure.header.seeMore')}
            </a>
          </div> */}
        </>
      )}
    </div>
  );
}

export default ThreeDSecure;
